import React from 'react'
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarFilterButton } from '@mui/x-data-grid'
import Spinner from '../../../components/Spinner'

const columns = [
  { field: 'name', headerName: 'Member', width: 350 },
  { field: 'email', headerName: 'Email', width: 300},
  { field: 'role', headerName: 'Role', type: 'number', width: 150},
]

export default function ManageUserInfo({ rowData }) {
  const CustomToolbarUserTable = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarFilterButton />
    </GridToolbarContainer>
  )

  const showTable = () => (
    <div style={{ width: 1100 }}>
      <DataGrid
        rows={rowData}
        columns={columns}
        density='compact'
        pageSize={10}
        autoHeight={true}
        rowsPerPageOptions={[10]}
        components={{
          Toolbar: CustomToolbarUserTable,
        }}
        align={"center"}
      />
    </div>
  )

  const loading = () => <div ><Spinner /></div>

  return rowData ? showTable() : loading()
}
